import { colors } from '../../theme/colors';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { components } from 'react-select';
import { globalSearchClasses } from './tailwindClassnames';

type TechnologySearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  // Both screens label the field for screen readers; the magnifier is
  // decorative and the input has no visible <label>.
  ariaLabel: string;
  id: string;
  testId: string;
};

// The search field above a technology grid: a magnifier, a full-width input and
// a clear button. Takes its look and its X from the search box every list page
// uses (globalSearchClasses), so search looks the same everywhere.
const TechnologySearchInput = ({
  value,
  onChange,
  placeholder,
  ariaLabel,
  id,
  testId,
}: TechnologySearchInputProps) => {
  const { t } = useTranslation();
  return (
    <div className="relative mt-4 w-full">
      <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M11.4351 10.0629H10.7124L10.4563 9.81589C11.3528 8.77301 11.8925 7.4191 11.8925 5.94625C11.8925 2.66209 9.23042 0 5.94625 0C2.66209 0 0 2.66209 0 5.94625C0 9.23042 2.66209 11.8925 5.94625 11.8925C7.4191 11.8925 8.77301 11.3528 9.81589 10.4563L10.0629 10.7124V11.4351L14.6369 16L16 14.6369L11.4351 10.0629ZM5.94625 10.0629C3.66838 10.0629 1.82962 8.22413 1.82962 5.94625C1.82962 3.66838 3.66838 1.82962 5.94625 1.82962C8.22413 1.82962 10.0629 3.66838 10.0629 5.94625C10.0629 8.22413 8.22413 10.0629 5.94625 10.0629Z"
            fill={colors['unlisted-medium-gray']}
          />
        </svg>
      </span>
      <input
        id={id}
        placeholder={placeholder}
        aria-label={ariaLabel}
        data-testid={testId}
        value={value}
        className={`${globalSearchClasses.input} w-full pl-9 ${value ? globalSearchClasses.applied : ''}`}
        onChange={(e) => onChange(e.target.value)}
      />
      {value && (
        <button
          type="button"
          aria-label={t('Clear keyword filter')}
          data-testid={`${testId}-clear-button`}
          className={globalSearchClasses.clearButton}
          onClick={() => onChange('')}
        >
          <components.CrossIcon size={20} />
        </button>
      )}
    </div>
  );
};

export default TechnologySearchInput;
